import React, {useState} from 'react';
import s from "../BankTransfer/BankTransfer.module.css";
import ToAnMondialStepOne from "./ToAnMondialStepOne/ToAnMondialStepOne";
import ToAnMondialStepTwo from "./ToAnMondialStepTwo/ToAnMondialStepTwo";

const ToAnMondial = () => {
    const [current, setCurrent] = useState(0);
    const [ourTransferData, setOurTransferData] = useState({})

    const steps = [
        {
            content: <ToAnMondialStepOne setCurrent={setCurrent}
                                         setTransferData={setOurTransferData}
            />
        },
        {
            content: <ToAnMondialStepTwo setCurrent={setCurrent}
                                         current={current}
                                         transferData={ourTransferData}
            />
        },
    ];

    return (
        <div className={s.wrapper}>
            {steps[current].content}
        </div>
    );
};

export default ToAnMondial;
